var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('home.pre-home.chooseExperience.title')))])
}
var staticRenderFns = []

export { render, staticRenderFns }